import React, {Component} from "react";
import TripCard from "../../components/TripCard";
import {LayoutHeaderConfig} from "../../components/MainLayout";
import tripsImg from "./trip-image.png";
import {Typography, Divider, Row, Col, Space, Skeleton} from 'antd';
import {bindActionCreators} from "redux";
import InfiniteScroll from 'react-infinite-scroller';
import {fetchPaidOrders, fetchPlans} from "../../store/billing/actions";
import {selectPaidOrders, selectPlans} from "../../store/billing/reducer";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {fetchTrips, fetchUserRidesSummary} from "../../store/ride/actions";
import {selectTrips, selectUserRidesSummary} from "../../store/ride/reducer";
import routesConfig from "../../routesConfig";
import momentJalaali from 'moment-jalaali';
import moment from "moment-jalaali";
import './style.css'

const {Title, Paragraph, Text} = Typography;

class Payments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: -1,
            last: false,
            size: 10,
            totalPages: undefined,
            content: []
        }
        this.now = new Date()
        this.now.setHours(this.now.getHours() + 1)
        moment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
    }

    componentDidMount() {
        this.props.fetchPaidOrders(0, this.state.size);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.paidOrders !== undefined && this.props.paidOrders.number !== undefined) {
            if (this.props.paidOrders.number != this.state.number) {
                if (this.props.paidOrders.number === 0) {
                    this.setState(this.props.paidOrders)
                } else {
                    let cont = this.state.content.concat(this.props.paidOrders.content)
                    this.setState(this.props.paidOrders)
                    this.setState({content: cont})
                }

            }
        }
    }

    render() {
        const paidOrders = this.state.content;
        return <React.Fragment>
            <LayoutHeaderConfig closeable={true} pageTitle="سفرها" menuEnabled={false} extra={[]}/>
            <Row className='px-40 mb-36'>
                <Col span={24} className="">
                    <Title level={2} className='f-30'>تاریخچه پرداخت ها</Title>
                </Col>
            </Row>
            <Row className='px-40 full-width-child'>
                {this.props.paidOrders === undefined && this.state.content.length === 0 ?
                    <Skeleton/> :
                    <InfiniteScroll
                        initialLoad={false}
                        loadMore={(page) => this.props.fetchPaidOrders(page, this.state.size)}
                        hasMore={this.props.paidOrders !== undefined && !this.props.paidOrders.last && !this.state.last}
                        threshold={700}
                    >
                        {paidOrders.map((paidOrder, key) => this.getPaymentCard(paidOrder, key))}
                    </InfiniteScroll>
                }

            </Row>
        </React.Fragment>
    }

    getPaymentCard(paidOrder, key) {
        const orderDate = moment(paidOrder.orderData);
        console.log(paidOrder.paymentGatewayId)
        return <Col span={24} key={key} className='payment-history-card mb-1'>
            <Row className='payment-history-card-row'>
                <p className='f-16 mb-0'>
                    زمان پرداخت
                </p>
                <p className='mr-auto f-16 mb-0'>
                    {orderDate.format('jYYYY/jM/jD HH:mm')}
                </p>
            </Row>
            <Row className='payment-history-card-row'>
                <p className='f-16 mb-0'>
                    مبلغ
                </p>
                <p className='mr-auto f-16 mb-0'>
                    {paidOrder.totalPrice}
                    &nbsp;
                    تومان
                </p>
            </Row>
            <Row className='payment-history-card-row'>
                <p className='color-primary mb-1'>
                    {'پرداخت از طریق ' + (paidOrder.paymentGatewayId === undefined ? "اعتبار" : "درگاه بانکی")
                    + ' بابت ' + paidOrder.title
                    }
                </p>
            </Row>
        </Col>;
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchPaidOrders,
    },
    dispatch);

const mapStateToProps = state => ({
    paidOrders: selectPaidOrders(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Payments))